import { render, staticRenderFns } from "./search404.vue?vue&type=template&id=36e9f60f&scoped=true&"
import script from "./search404.vue?vue&type=script&lang=js&"
export * from "./search404.vue?vue&type=script&lang=js&"
import style0 from "./search404.vue?vue&type=style&index=0&id=36e9f60f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e9f60f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/zklink/web/zklink-explorer-web-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36e9f60f')) {
      api.createRecord('36e9f60f', component.options)
    } else {
      api.reload('36e9f60f', component.options)
    }
    module.hot.accept("./search404.vue?vue&type=template&id=36e9f60f&scoped=true&", function () {
      api.rerender('36e9f60f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/error-page/search404.vue"
export default component.exports